import shouldForwardProp from '@styled-system/should-forward-prop'
import React from 'react'
import styled, { keyframes } from 'styled-components'

import { Flex } from '../Primitives'

/**
 * bounce keyframe for the loading dots.
 *
 * Fades each dot from full to half opacity while nudging it down, then holds —
 * combined with `alternate infinite` this gives the gentle bouncing pulse.
 * Uses plain CSS keyframes instead of an animation library so the
 * component no longer pulls in an animation library.
 */
const bounce = keyframes`
	0% {
		opacity: 1;
		transform: translateY(0);
	}
	40% {
		opacity: 0.5;
		transform: translateY(5px);
	}
	100% {
		opacity: 0.5;
		transform: translateY(5px);
	}
`

const Dot = styled('div').withConfig({ shouldForwardProp })`
	display: inline-block;
	width: 10px;
	height: 10px;
	margin: 10px 2px;
	border-radius: 5px;
	background-color: #555;
	animation: ${bounce} 0.8s ease-out infinite alternate;
`

/**
 * LoadingIcon component.
 *
 * This component renders a loading animation icon.
 *
 * @component
 * @example
 * // Usage example:
 * <LoadingIcon />
 *
 * @returns {JSX.Element} The LoadingIcon component.
 */
export const LoadingIcon = ({ count = 4, ...props }) => {
	const fingers = Array.from({ length: count }, (_, index) => index * 0.15)

	return (
		<Flex {...props}>
			{fingers.map((finger) => {
				const key = `bnb__loading__finger--${finger}`
				return <Dot key={key} style={{ animationDelay: `${finger}s` }} />
			})}
		</Flex>
	)
}
